<template>
  <div class="subservice">
    <div class="gradient" @click="show = true">
      <icon name="wrench" scale="2"></icon>
    </div>
    <hr>
    <div class="title" @click="show = true">{{ item.title }} </div>
    <transition name="flip" enter-active-class="animated bounceInDown" leave-active-class="animated bounceOutUp">
      <div class="mask" v-show="show">
        <div class="info container">
          <div class="row row-centered">
            <div class="close" @click="show = false">
              <icon name="times" scale="1"></icon>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.info }}</p>
            <ul v-if="item.list">
              <li v-for="(info, key) in item.list" v-bind:key="key">
                {{ info }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import Icon from 'vue-awesome/components/Icon'
  import 'animate.css/source/flippers/flipInX.css'
  import 'vue-awesome/icons/wrench'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/circle'
  export default {
    props: ['item'],
    components: {
      Icon
    },
    data () {
      return {
        show: false
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '../common/css/vars'

.close
  position absolute
  top 5px
  right 10px
  cursor pointer

.mask
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.9)
  position fixed
  top 0
  left 0
  overflow hidden
  z-index 99

.info
  position relative
  width 90%
  max-height calc(100% - 73px - 160px)
  overflow-y auto
  padding 55px 20px
  background radial-gradient(ellipse at center, rgb(27, 30, 34) 0, rgba(0, 0, 0, 0.96) 100%)
  margin 80px auto 0
  border 5px solid #333
  cursor auto

  ul
    // list-style none
    text-align center
    list-style-position inside
    text-shadow 1px 1px 2px black, 0 0 0.2em $white
    padding-left 0

    li
      -webkit-column-break-inside avoid
      page-break-inside avoid
      break-inside avoid
      padding 8px 0

.fa-icon
  width auto
  height 2em
  max-width 100%
  max-height 100%
  margin 10px 0

hr
  border none
  height 2px
  background-color #333
  margin 0

h1
  font-size 16px
  font-weight 600

.gradient
  background radial-gradient(ellipse at center, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%)

.service
  background rgba(27, 30, 34, 0.9)
  padding 15px

.subservice
  background-color #1b1e22
  border 2px solid #333
  max-width 180px
  margin 15px auto
  cursor pointer

.title
  padding 10px 2px

@media only screen and (min-width: 992px)
  .info
    overflow hidden
    font-size 14px

    ul
      padding 0 20px
      text-align left
      column-count 2
</style>



// WEBPACK FOOTER //
// ServiceItem.vue?e396861e